import qs from "qs";
import authAxios, { authHeader } from "./data";
import {
  ISendFormForReviewRequest,
  ISendPayoffQuotesForReviewRequest,
} from "../pages/RequestsAndForms/types";

const fetchTemplates = async (contractNumber: string) => {
  const response = await authAxios.get(
    `/api//ExternalUsersContracts/${contractNumber}/Requests/Templates`,
    {
      headers: authHeader(),
    },
  );

  return response.data;
};

const sendForm = async (
  contractNumber: string,
  req: ISendFormForReviewRequest,
) => {
  const response = await authAxios.post(
    `/api//ExternalUsersContracts/${contractNumber}/Requests/FillableForms`,
    req,
    {
      headers: authHeader(),
    },
  );

  return response.data;
};

const sendPayoffQuotes = async (
  contractNumber: string,
  req: ISendPayoffQuotesForReviewRequest,
) => {
  const response = await authAxios.post(
    `/api//ExternalUsersContracts/${contractNumber}/Requests/PayoffQuotes`,
    req,
    {
      headers: authHeader(),
    },
  );

  return response.data;
};

const download = async (contractNumber: string, id: string) => {
  const response = await authAxios.get(
    `/api/ExternalUsersContracts/${contractNumber}/Requests/${id}/download`,
    {
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
      headers: authHeader(),
      responseType: "blob",
    },
  );

  return response.data;
};

const PortalRequestsAndFormsService = {
  fetchTemplates,
  sendForm,
  sendPayoffQuotes,
  download,
};

export default PortalRequestsAndFormsService;
